import { parse } from 'date-fns';

export function dateSRLocale(date: Date | any): string {
  if (!date) {
    return '';
  }
  const monthNum = date.getMonth() + 1;
  const day = date.getDate();
  return `${day >= 10 ? day : `0${date.getDate(day)}`}.${
    monthNum < 10 ? `0${monthNum}` : monthNum
  }.${date.getFullYear()}`;
}

export function formattedTime(date: Date): string {
  return `${date.getHours()}:${
    date.getMinutes() >= 10 ? `${date.getMinutes()}` : `0${date.getMinutes()}`
  }`;
}

// date formatter for sending the data to the BE
export function dateFormatter(date: Date): string {
  if (!date) {
    return '';
  }
  const month =
    date.getMonth() + 1 >= 10 ? date.getMonth() + 1 : `0${date.getMonth() + 1}`;
  const day = date.getDate() >= 10 ? date.getDate() : `0${date.getDate()}`;
  return `${date.getFullYear()}-${month}-${day}`;
}

export function parseDate(dateStr: string): Date {
  return parse(dateStr, 'yyyy-MM-dd', new Date());
}

// ─── Belgrade timezone utilities ─────────────────────────────────────────────

const BELGRADE_TZ = 'Europe/Belgrade';

function beogradeOffsetMs(utcDate: Date): number {
  const localStr = utcDate.toLocaleString('sv-SE', { timeZone: BELGRADE_TZ });
  return (
    new Date(localStr.replace(' ', 'T') + 'Z').getTime() - utcDate.getTime()
  );
}

export function utcToBeogradDatetime(utcStr: string): string {
  const normalized =
    utcStr.endsWith('Z') ||
    utcStr.includes('+') ||
    /\d{2}:\d{2}$/.test(utcStr.slice(-6))
      ? utcStr
      : utcStr + 'Z';
  const utcDate = new Date(normalized);
  const offsetMs = beogradeOffsetMs(utcDate);
  const belgradeDate = new Date(utcDate.getTime() + offsetMs);
  return belgradeDate.toISOString().slice(0, 16);
}

export function beogradDatetimeToUtc(localStr: string): string {
  const approxUtc = new Date(localStr + ':00Z');
  const offsetMs1 = beogradeOffsetMs(approxUtc);
  const actualUtc1 = new Date(approxUtc.getTime() - offsetMs1);
  const offsetMs2 = beogradeOffsetMs(actualUtc1);
  const actualUtc = new Date(approxUtc.getTime() - offsetMs2);
  return actualUtc.toISOString().slice(0, 19) + 'Z';
}

export function utcTimeToBeogradTime(
  timeStr: string,
  referenceDate: string
): string {
  const timePart = timeStr.slice(0, 5);
  const utcDate = new Date(`${referenceDate}T${timePart}:00Z`);
  const offsetMs = beogradeOffsetMs(utcDate);
  const belgradeDate = new Date(utcDate.getTime() + offsetMs);
  const h = belgradeDate.getUTCHours().toString().padStart(2, '0');
  const m = belgradeDate.getUTCMinutes().toString().padStart(2, '0');
  return `${h}:${m}`;
}

export function beogradTimeToUtcTime(
  timeStr: string,
  referenceDate: string
): string {
  const approxUtc = new Date(`${referenceDate}T${timeStr}:00Z`);
  const offsetMs1 = beogradeOffsetMs(approxUtc);
  const actualUtc1 = new Date(approxUtc.getTime() - offsetMs1);
  const offsetMs2 = beogradeOffsetMs(actualUtc1);
  const actualUtc = new Date(approxUtc.getTime() - offsetMs2);
  const h = actualUtc.getUTCHours().toString().padStart(2, '0');
  const m = actualUtc.getUTCMinutes().toString().padStart(2, '0');
  return `${h}:${m}`;
}

export function utcDatetimeSRLocale(utcStr: string): string {
  if (!utcStr) return '';
  const normalized =
    utcStr.endsWith('Z') ||
    utcStr.includes('+') ||
    /\d{2}:\d{2}$/.test(utcStr.slice(-6))
      ? utcStr
      : utcStr + 'Z';
  const utcDate = new Date(normalized);
  const parts = new Intl.DateTimeFormat('en-GB', {
    timeZone: BELGRADE_TZ,
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  }).formatToParts(utcDate);
  const day = parts.find((p) => p.type === 'day')?.value ?? '';
  const month = parts.find((p) => p.type === 'month')?.value ?? '';
  const year = parts.find((p) => p.type === 'year')?.value ?? '';
  return `${day}.${month}.${year}`;
}
